/*global jQuery:false */
jQuery(document).ready(function () {
    'use strict';

    jQuery('#header--search--input, #sticky-header--search--input').keyup(function () {
        var $this = $(this);
        var $button = $this.attr('id') === 'header--search--input' ? $('#header--search--button') : $('#sticky-header--search--button');
        if ($this.val() !== '') {
            $button.removeAttr('disabled');
        } else {
            $button.attr('disabled', 'disabled');
        }
    });

    $('#header--search--button').one("click", function (e) {
        $(this).css("pointer-events", 'none');
    });
});